import React from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";

import Logo1 from "../../images/logos/1.PNG";
import Logo2 from "../../images/logos/2.PNG";
import Logo3 from "../../images/logos/3.PNG";
import Logo4 from "../../images/logos/4.PNG";
import Logo5 from "../../images/logos/5.PNG";
import Logo6 from "../../images/logos/6.PNG";
import Logo7 from "../../images/logos/7.PNG";
import Logo8 from "../../images/logos/8.PNG";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import "slick-carousel/slick/slick.css";

const Logo = styled.div`
    ${tw`flex items-center justify-center px-6 py-6`}

    img {
        ${tw`transition-all duration-300 ease-in-out w-full`}
        opacity:0.8;
        @media (min-width: 768px) {
            width: 70%;
        }
    }
`;

// Contenedor general
const Container = tw.div` mt-10 relative -mx-8 py-10`;

const BrandsCarousel = () => {
    const logos = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8];

    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        pauseOnHover: false,
        draggable: false,
        speed: 1000,
        slidesToShow: 6, // default en desktop
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024, // tablets
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 768, // móviles
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    };

    return (
        <Container>
            <HeadingTitle>Confían en Mylen</HeadingTitle>
            <Slider {...settings}>
                {logos.map((logo, index) => (
                    <Logo key={index}>
                        <img src={logo} alt={`Brand ${index + 1}`} />
                    </Logo>
                ))}
            </Slider>
        </Container>
    );
};

export default BrandsCarousel;
